module.exports = __webpack_public_path__ + "static/media/instagram-black.5ce978c2.svg";